// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"accounting-terms_subHeader__fvu8_","linkList":"accounting-terms_linkList__RCqIC"};